//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import Modal from './Modal.vue';
import tableConfig from './tableConfig';

export default {
  components: { Modal },
  data() {
    return {
      editingRange: {
        show: false,
        isCreating: false,
        existingRanges: [],
      },
      tableConfig,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('tradersFees', ['data']),

    getDataForPayout() {
      if (!this.data) return [];

      const merchantRanges = this.data.makerPayOut || [];
      const traderRanges = this.data.takerPayIn || [];

      const res = merchantRanges.reduce((acc, cur, i) => {
        const traderRange = traderRanges[i];
        if (traderRange && cur.amountFrom === traderRange.amountFrom && cur.amountTo === traderRange.amountTo) {
          acc.push({
            amountFrom: cur.amountFrom,
            amountTo: cur.amountTo,
            merchantFee: cur.profit,
            traderProfit: traderRange.profit,
          });
        }
        return acc;
      }, []);

      return res;
    },

    getDataForPayin() {
      if (!this.data) return [];

      const merchantRanges = this.data.takerPayOut || [];
      const traderRanges = this.data.makerPayIn || [];

      const res = merchantRanges.reduce((acc, cur, i) => {
        const traderRange = traderRanges[i];
        if (traderRange && cur.amountFrom === traderRange.amountFrom && cur.amountTo === traderRange.amountTo) {
          acc.push({
            amountFrom: cur.amountFrom,
            amountTo: cur.amountTo,
            merchantFee: cur.profit,
            traderProfit: traderRange.profit,
          });
        }
        return acc;
      }, []);

      return res;
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('tradersFees', {
      editFeesAction: 'editFees',
      loadDataAction: 'loadData',
    }),

    createRangeFor(type) {
      this.editingRange.show = true;
      this.editingRange.isCreating = true;
      this.editingRange.data = { type };
      this.editingRange.existingRanges = this.calculateExistingRanges(type);
    },

    changeFor(type, content, index) {
      this.editingRange.show = true;
      this.editingRange.isCreating = false;
      this.editingRange.data = { ...content, type, index };
      this.editingRange.existingRanges = this.calculateExistingRanges(type);
    },

    calculateExistingRanges(type) {
      let ranges = [];

      if (type === 'payout') {
        ranges = [
          ...this.data.makerPayOut || [],
          ...this.data.takerPayIn || [],
        ];
      } else if (type === 'payin') {
        ranges = [
          ...this.data.takerPayOut || [],
          ...this.data.makerPayIn || [],
        ];
      }

      const allValues = ranges.flatMap((range) => [
        range.amountFrom,
        range.amountTo,
      ]).filter((value) => value !== undefined && value !== null);

      if (allValues.length === 0) {
        return [0, 0];
      }

      const min = Math.min(...allValues);
      const max = Math.max(...allValues);

      return [min, max];
    },

    async deleteRangeFor(type, content) {
      try {
        this.setGeneralProgress(true);

        const { amountFrom, amountTo } = content;
        const updatedData = { ...this.data };

        if (type === 'payout') {
          updatedData.makerPayOut = updatedData.makerPayOut.filter((range) => !(range.amountFrom === amountFrom && range.amountTo === amountTo));
          updatedData.takerPayIn = updatedData.takerPayIn.filter((range) => !(range.amountFrom === amountFrom && range.amountTo === amountTo));
        } else if (type === 'payin') {
          updatedData.takerPayOut = updatedData.takerPayOut.filter((range) => !(range.amountFrom === amountFrom && range.amountTo === amountTo));
          updatedData.makerPayIn = updatedData.makerPayIn.filter((range) => !(range.amountFrom === amountFrom && range.amountTo === amountTo));
        }

        await this.editFeesAction(updatedData);
        this.setSuccessNotification('You have successfully deleted fee range');
      } catch (error) {
        this.setErrorNotification(error.message);
      } finally {
        this.setGeneralProgress(false);
        await this.loadDataAction({});
      }
    },

    async handleCreate({ payload, type }) {
      const {
        amountFrom,
        amountTo,
        merchantFee: profitMerchant,
        traderProfit: profitTrader,
      } = payload;

      const dataToSave = { ...this.data };

      if (type === 'payout') {
        dataToSave.makerPayOut.push({ amountFrom, amountTo, profit: profitMerchant });
        dataToSave.takerPayIn.push({ amountFrom, amountTo, profit: profitTrader });
      } else if (type === 'payin') {
        dataToSave.takerPayOut.push({ amountFrom, amountTo, profit: profitMerchant });
        dataToSave.makerPayIn.push({ amountFrom, amountTo, profit: profitTrader });
      }

      try {
        this.setGeneralProgress(true);
        await this.editFeesAction(dataToSave);
        this.setSuccessNotification('You have successfully added fee range');
      } catch (error) {
        this.setErrorNotification(error.message);
      } finally {
        this.setGeneralProgress(false);
        await this.loadDataAction({});
      }
    },

    async handleSave({ payload, type }) {
      const {
        amountFrom,
        amountTo,
        merchantFee: profitMerchant,
        traderProfit: profitTrader,
      } = payload;

      const updatedData = { ...this.data };

      const oldAmountFrom = this.editingRange.data.amountFrom;
      const oldAmountTo = this.editingRange.data.amountTo;

      if (type === 'payout') {
        updatedData.makerPayOut = updatedData.makerPayOut.map((range) => {
          if (range.amountFrom === oldAmountFrom && range.amountTo === oldAmountTo) {
            return { amountFrom, amountTo, profit: profitMerchant };
          }
          return range;
        });
        updatedData.takerPayIn = updatedData.takerPayIn.map((range) => {
          if (range.amountFrom === oldAmountFrom && range.amountTo === oldAmountTo) {
            return { amountFrom, amountTo, profit: profitTrader };
          }
          return range;
        });
      } else if (type === 'payin') {
        updatedData.takerPayOut = updatedData.takerPayOut.map((range) => {
          if (range.amountFrom === oldAmountFrom && range.amountTo === oldAmountTo) {
            return { amountFrom, amountTo, profit: profitMerchant };
          }
          return range;
        });
        updatedData.makerPayIn = updatedData.makerPayIn.map((range) => {
          if (range.amountFrom === oldAmountFrom && range.amountTo === oldAmountTo) {
            return { amountFrom, amountTo, profit: profitTrader };
          }
          return range;
        });
      }

      try {
        this.setGeneralProgress(true);
        await this.editFeesAction(updatedData);
        this.setSuccessNotification('You have successfully edited fees range');
      } catch (error) {
        this.setErrorNotification(error.message);
      } finally {
        this.setGeneralProgress(false);
        await this.loadDataAction({});
      }
    },

    applyFilters() {
      this.loadData();
    },
  },
};
